import { useEffect, useState } from 'react';
import { prefersReducedMotion } from '@lib/utils/motion';

/**
 * Keeps the last non-null `value` on screen for `ms` after it went away, so it can play an exit animation
 * (`leaving` meanwhile). A new value replaces it at once; under reduced motion it leaves at once.
 */
export function usePresence<T>(value: T | null | undefined, ms: number): { shown: T | null; leaving: boolean } {
  const [kept, setKept] = useState<T | null>(value ?? null);
  // the latest value is the one that leaves (derived state, set during render)
  if (value != null && value !== kept) setKept(value);
  const gone = value == null;
  useEffect(() => {
    if (!gone) return;
    const t = window.setTimeout(() => setKept(null), prefersReducedMotion() ? 0 : ms);
    return () => window.clearTimeout(t);
  }, [gone, ms]);
  return { shown: value ?? kept, leaving: gone && kept != null };
}
